import { Home, Cloud, User, LogIn } from "lucide-react";
import Index from "./pages/Index.jsx";
import PersonalizedWeatherPage from "./pages/PersonalizedWeatherPage.jsx";
import AuthPage from "./pages/AuthPage.jsx";

/**
 * Central place for defining the navigation items. Used for navigation components and routing.
 */
export const navItems = [
  {
    title: "Weather",
    to: "/",
    icon: <Cloud className="h-4 w-4" />,
    page: <Index />,
  },
  {
    title: "Personalized",
    to: "/personalized",
    icon: <User className="h-4 w-4" />,
    page: <PersonalizedWeatherPage />,
  },
  {
    title: "Sign In",
    to: "/auth",
    icon: <LogIn className="h-4 w-4" />,
    page: <AuthPage />,
  },
];
